"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ReadMoreModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadMoreModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../dsl/backoffice");
const services_1 = require("../../services");
const form_1 = require("../_abstract/form");
const form_2 = require("../_components/form");
const _contracts_1 = require("../_contracts");
/**
 * TODO:
 *   - Fix order of properties/methods/getters/setters.
 *   - Add missing JSDoc blocks.
 *
 * Component that contains a complete questionnaire needed to **EDIT** the `ReadMore`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let ReadMoreModuleForm = ReadMoreModuleForm_1 = class ReadMoreModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.DashmixIconName = backoffice_1.DashmixIconName;
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = ReadMoreModuleForm_1.getInitialContent();
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.ReadMore,
            size: {
                colSpan: 6,
                rowSpan: 1,
                isResizable: true,
                minColSpan: 1,
                minRowSpan: 1,
                maxColSpan: 6
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            articles: [],
            showThumbnails: false,
            showSponsored: false,
            titleVersion: ''
        };
    }
    /**
     * Alternative titles options.
     */
    get titleOptions() {
        return [
            { label: `${this.$t('forms.shared.titleVersion.none')}`, value: '' },
            ...Object.values(_contracts_1.TitleVersion).map(value => ({
                label: `${this.$t('forms.shared.titleVersion.' + value)}`,
                value
            }))
        ];
    }
    deleteArticle(index) {
        const articlesCopy = [...this._content.articles];
        articlesCopy.splice(index, 1);
        this._content.articles = articlesCopy;
    }
    findArticleSource(index) {
        this.pickRelated(services_1.Picker.Content, (source) => this.changeArticleSource(index, source));
    }
    findNewArticleSource() {
        this.pickRelated(services_1.Picker.Content, (source) => this.addNewArticle(source));
    }
    hasArticle(index) {
        return !!this._content.articles[index] && !!this._content.articles[index].value;
    }
    addNewArticle(source) {
        this._content.articles = [...this._content.articles, source];
        this.describe(source);
    }
    /**
     * @inheritDoc
     * @override
     */
    afterInitialContentSetup() {
        this.$nextTick(() => {
            for (const a of this._content.articles) {
                this.describe(a);
            }
        });
    }
    changeArticleSource(index, source) {
        const articlesCopy = [...this._content.articles];
        articlesCopy[index] = source;
        this.describe(source);
        this._content.articles = articlesCopy;
    }
};
ReadMoreModuleForm = ReadMoreModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'ReadMoreModuleForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixSelect: backoffice_1.DashmixSelect,
            FormErrors: form_2.FormErrors
        },
        template: `
    <div>

      <!-- Alternative title -->
      <div class="form-group">
        <label for="version">{{ $t('forms.shared.alternativeTitle') }}</label>
        <DashmixSelect :model.sync="_content.titleVersion" name="titleVersion"
                       :options="titleOptions" :searchable="false" />
      </div>

      <div class="form-group">
        <DashmixCheck :label="$t('forms.readMore.showThumbnails')" name="showThumbnails"
                      :model.sync="_content.showThumbnails" />
      </div>

      <div class="form-group">
        <DashmixCheck :label="$t('forms.readMore.showSponsored')" name="showSponsored"
                      :model.sync="_content.showSponsored" />
      </div>

      <div class="form-group mb-4">
        <label for="list_value" class="d-block">{{ $t('forms.readMore.articles') }}</label>

        <template v-for="(article, index) in _content.articles">
          <div class="bg-light py-3 row mx-0 mb-3">
            <div class="col-11 d-flex justify-content-between align-items-center">
              <p class="mb-0">
                <strong v-if="hasArticle(index)" class="mr-2">
                  {{ $t('forms.shared.chosenSource') }}</strong>{{ description(article) }}
              </p>
              <DashmixButton size="small" variant="alt" :icon="DashmixIconName.SearchSolid" label="Zmień"
                             @click="() => findArticleSource(index)" />
            </div>

            <div class="col-1 d-flex align-items-center p-0">
              <DashmixButton variant="icon" :icon="DashmixIconName.TrashSolid" theme="danger"
                             @click="() => deleteArticle(index)" />
            </div>
          </div>
        </template>

        <DashmixButton :icon="DashmixIconName.PlusSolid" variant="icon" :label="$t('forms.readMore.addArticle')"
                       @click="findNewArticleSource" />
      </div>
        <!-- Form errors -->
        <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3" />
    </div>
  `
    })
], ReadMoreModuleForm);
exports.ReadMoreModuleForm = ReadMoreModuleForm;
//# sourceMappingURL=ReadMore.form.js.map